import { seatApplicationTemplateStatusValueLabels } from './value-labels.js';
export const seatApplicationTemplatesCube = {
    category: 'Applications',
    description: 'Application form templates with their status and default settings.',
    label: 'Application Templates',
    requiredModule: 'hasTenure',
    measures: {
        'seat_application_templates.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'seat_application_templates.description': {
            label: 'Description',
            narrative: true,
            type: 'string',
        },
        'seat_application_templates.is_default': { label: 'Is Default', type: 'boolean' },
        'seat_application_templates.name': { label: 'Name', type: 'string' },
        'seat_application_templates.status': {
            label: 'Status',
            type: 'string',
            valueLabels: seatApplicationTemplateStatusValueLabels,
        },
    },
    timeDimensions: {
        'seat_application_templates.created_at': { label: 'Created At', type: 'date' },
        'seat_application_templates.updated_at': { label: 'Updated At', type: 'date' },
    },
};
